import { render } from "./FormImage.vue?vue&type=template&id=3e583c0a&ts=true"
import script from "./FormImage.vue?vue&type=script&lang=ts"
export * from "./FormImage.vue?vue&type=script&lang=ts"

import "./FormImage.vue?vue&type=style&index=0&id=3e583c0a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__